module.exports = "/_next/static/images/Connections-bc20e2a6976bbd2b6a84e8ba9c9bc25d.webp";